const config = {
  API_URL: "//pro.safebuilt.com/",
  PROTOCOL: "https:",
  API_CLIENT_ID: "safebuilt_prod",
  API_CLIENT_SECRET: "safebuilt_prod",
  INTEGRATION_USER_EMAIL: "cc_reviewer@safebuilt.com",
  INTEGRATION_USER_PASSWORD: "cc_safecv",
  WS_URL: "wss://eb7q1zc941.execute-api.us-east-2.amazonaws.com/production",
  FULL_STORY_ENABLED: false,
  PDFTRON_VISIBILITY: true,
  FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED: true,
  FEATURE_SHARE_VISIBILITY_ENABLED: false,
  FEATURE_REVIEWER_SSO_ENABLED: true,
  FEATURE_GT_UPLOAD_ENABLED: false,
  FEATURE_FTS_ENABLED_FROM: 1000,
  FEATURE_HIGHLIGHT_ENABLED: true,
};

module.exports = { config };
